import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const calorieDifficulty = useStore((state) => state.calorieDifficulty);
  const setCalorieDifficulty = useStore((state) => state.setCalorieDifficulty);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.calorieDifficulty.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={calorieDifficulty}
          onChange={(value) => {
            setCalorieDifficulty(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'calorie-difficulty',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Yes"}>
            <span>✅</span> {t('onboarding.calorieDifficulty.options.yes')}
          </Option>
          <Option value={"No"}>
            <span>❌</span> {t('onboarding.calorieDifficulty.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
